import {
    CONSULTAR_SERVICIOS,
    SERVICIOS_CONSULTADOS,
    ERROR_CONSULTANDO_SERVICIOS,
    GESTIONAR_SERVICIO,
    GESTION_EXITO,
    GESTION_ERROR,
    LIMPIAR_MENSAJES_SERVICIO,
    serviciosConsultados,
    errorConsultandoServicios,
    gestionExito,
    gestionError,
    VENTANA_AYUDA_SERVICIO
} from "./adminServicioActions";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroAdminServicios } from "../modelo/AdminServicio";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import { SolicitudAdminServicio, Servicio } from "../modelo/AdminServicio";
import { TIPO_CONSULTA } from "../modelo/TipoConsulta";

export const consultarServiciosEpic = action$ =>
    action$.ofType(CONSULTAR_SERVICIOS)
        .mergeMap((action: any) => {

            const url = `sat/consultar/servicios?${obtenerFiltroServicios(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return serviciosConsultados(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoServicios()];
                });
        });

export const gestionarServicioEpic = action$ =>
    action$.ofType(GESTIONAR_SERVICIO)
        .mergeMap((action: any) => {

            const url = `sat/administrar/servicio`;

            return authenticatedAjax
                .post(
                    url,
                    action.solicitud,
                    { 'Content-Type': 'application/json' }
                )
                .map((response) => {
                    return gestionExito();
                }).catch(response => {
                    const respuesta = response.response;
                    const mensajeRespuesta = (respuesta && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                    return [gestionError(mensajeRespuesta)];
                });

        });

export const servciosReducer = (state = {
    estado: REQUEST.NONE,
    estadoAccion: REQUEST.NONE,
    mensajeAccion: undefined,
    showAlert: false,
    servicios: [],
    paginas: 0,
    totalParametrosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0,
    ventanaAyudaServicio: undefined
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_SERVICIOS:
            return {
                ...state,
                estado: REQUEST.PENDING,
                servicios: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalParametrosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
                showAlert: false
            };
        case SERVICIOS_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                servicios: action.datosEntidad,
                paginas: action.paginas,
                totalParametrosConsulta: action.totalDatos,
                showAlert: false
            };
        case ERROR_CONSULTANDO_SERVICIOS:
            return {
                ...state,
                estado: REQUEST.ERROR,
                servicios: [],
                paginas: 0,
                totalParametrosConsulta: 0,
                showAlert: false
            };
        case GESTIONAR_SERVICIO:
            return {
                ...state,
                estado: REQUEST.PENDING,
                servicios: servicioEnGestion(action.solicitud, state.servicios),
                showAlert: false
            };
        case GESTION_EXITO:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.SUCCESS,
                showAlert: true
            };
        case GESTION_ERROR:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.ERROR,
                mensajeAccion: action.mensaje,
                showAlert: true
            };
        case LIMPIAR_MENSAJES_SERVICIO:
            return {
                ...state,
                estado: REQUEST.NONE,
                estadoAccion: REQUEST.NONE,
                mensajeAccion: undefined,
                showAlert: false,
                servicios: [],
                paginas: 0,
                totalParametrosConsulta: 0,
                tamanoPagina: 10,
                paginaActual: 0
            };
        case VENTANA_AYUDA_SERVICIO:
            return {
                ...state,
                ventanaAyudaServicio: true
            };
        default:
            return state;
    }
};

const obtenerFiltroServicios = (filtro: FiltroAdminServicios) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.consecutivo) params.set('consecutivo', filtro.consecutivo.toString());
        if (filtro.palabraClave) params.set('palabraClave', filtro.palabraClave);
        if (filtro.claveSN && filtro.valorSN) params.set(filtro.claveSN, filtro.valorSN);
        if (filtro.tipoFecha && filtro.fecha && filtro.complementoFecha) {
            params.set(filtro.tipoFecha, filtro.fecha);
            params.set('complementoFecha', filtro.complementoFecha.toString());
        }
        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');
        if (filtro.tipoConsulta) params.set('tipoConsulta', filtro.tipoConsulta);
        else params.set('tipoConsulta', TIPO_CONSULTA.CONSULTA_CON_FILTRO);
    }

    return params.toString();
};

const servicioEnGestion = (solicitud: SolicitudAdminServicio, parametros: Array<Servicio>) => {
    return parametros.map(parametro => {
        if (parametro.consecutivo === solicitud.datos.consecutivo) {
            parametro.pendiente = true;
        }
        return parametro;
    });
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/modulos/adminServicioReducers.ts